import { render, staticRenderFns } from "./kvkk-legal-document-template-view.vue?vue&type=template&id=620e0d32"
import script from "./kvkk-legal-document-template-view.vue?vue&type=script&lang=js"
export * from "./kvkk-legal-document-template-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports